export default "/_next/static/images/img1-c7f7e42067c83cdb3fcdf17a405a98ef.png";